module.exports = __webpack_public_path__ + "resources/warning-filled-178b4e9aa6aa7596e353b47e004222da.svg";